export default __webpack_public_path__ + "static/media/44.8e26c82a.jpg";